import { render, staticRenderFns } from "./RipaTree.vue?vue&type=template&id=179fb6d7"
import script from "./RipaTree.vue?vue&type=script&lang=js"
export * from "./RipaTree.vue?vue&type=script&lang=js"
import style0 from "./RipaTree.vue?vue&type=style&index=0&id=179fb6d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports